(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	window.addEventListener("resize", function () {
		$(".product-section .js-media-list").each(function () {
			this.swiper.destroy();
		});
		$(".product-section .js-media-sublist").each(function () {
			this.swiper.destroy();
		});

		swiperInit();
	});

	swiperInit();
})();



document.querySelector(".modal-close-button").addEventListener("click", function () {

	document.querySelectorAll(".product-section .js-media-list").forEach(function (el) {
		if (el.swiper) {
			el.swiper.destroy(true, true);
		}
	});

	document.querySelectorAll(".product-section .js-media-sublist").forEach(function (el) {
		if (el.swiper) {
			el.swiper.destroy(true, true);
		}
	});

	swiperInit();

});
